<div class="br-card {{ cor }}">
	<div class="card-content">
		<div class="texto">
			<i class="fas {{icone}}"></i> {{ descricao }}
			<i class="fas fa-info-circle" pTooltip="{{ textoAjuda }}" tooltipEvent="hover" *ngIf="ajuda"></i>
		</div>
		<div class="numero mt-3">{{ quantidade }}</div>
	</div>
</div>
